module.exports = "/_next/static/images/66ad05ed6809583e89946c68ff614333-NU_ComplianceTeam_ParkerLogo-08 1_xs.png.webp";